exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=date]::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  display: none;\r\n}\r\n\r\n.alert-message {\r\n  width: 300px;\r\n  position: absolute;\r\n  left: 0px;\r\n  right: 50%;\r\n  background: #d34a36;\r\n  color: white;\r\n  text-align: center;\r\n  border: solid 3px white;\r\n  border-radius: 10px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/rooms/rooms.component.css
// module id = ../../../../../src/app/rooms/rooms.component.css
// module chunks = main